<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <project-control></project-control>
      <project-view></project-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ProjectControl from "@/components/projects/projectControl";
import ProjectView from "@/components/projects/projectView";

export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  methods: {},
  mounted() {
    //!!this.fid && (this.client = this.fid)
    if (!!this.fid) {
      ////console.log(this.fid);
      this.client = this.fid;
    }
  },
  computed: {
    //client: ProjectStore.client
    client: {
      get() {
        return this.$store.state.projects.client;
      },
      set(val) {
        this.$store.commit("projects/setState", { prop: "client", value: val });
      }
    }
  },
  components: {
    ProjectControl,
    ProjectView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
